module.exports = __webpack_public_path__ + "img/im_logo@2x.0dc7b3d5.png";